import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const ICON_BASE_PATH = "/uploads/Categories/";

const slugify = (text) => {
    return text
        .toLowerCase()
        .trim()
        .replace(/&/g, 'and')
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_-]+/g, '-')
        .replace(/^-+|-+$/g, '');
};

export default function CardsGame() {
    const [data, setData] = useState({ Categories: [] });
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetch('/uploads/data.json')
            .then(response => {
                if (!response.ok) throw new Error('Failed to fetch data.json');
                return response.json();
            })
            .then(fetchedData => {
                setData(fetchedData);
            })
            .catch(error => {
                console.error("Could not fetch data:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    const gameCategories = data.Categories || [];

    return (
        <section className="relative w-full overflow-hidden">
            <div className="mx-auto max-w-6xl px-4 p-14 sm:px-6">
                <div className="mb-12">
                    <p className="font-uber text-[26px] font-bold leading-[30px] sm:text-[32px] sm:leading-[38px] xl-custom:text-[32px] xl-custom:leading-[42px] text-center max-w-4xl mx-auto">
                        Playables span across arcade, puzzle, and sports genres—each crafted to boost interaction and engagement. Every experience is designed to entertain users while driving measurable business results.
                    </p>
                </div>

                {isLoading && <p className="text-center">Loading game categories...</p>}

                {!isLoading && gameCategories.length === 0 && <p className="text-center">No categories found.</p>}

                <div className="flex flex-wrap justify-center gap-6">
                    {gameCategories.map((categoryItem, index) => {
                        const categoryName = categoryItem.name;
                        const categorySlug = slugify(categoryName);

                        const imagePath = ICON_BASE_PATH + categoryItem.CategoryIcon;

                        const linkTo = `/categories/${categorySlug}`;

                        return (
                            <Link
                                to={linkTo}
                                key={index}
                                className="bg-gray-200 rounded-lg p-4 flex flex-col items-center text-center shadow-lg w-full sm:w-[calc(50%-12px)] md:w-[calc(33.33%-16px)] lg:w-[calc(25%-18px)]"
                            >
                                <div className="mb-2 w-20 h-20 flex items-center justify-center">
                                    <img
                                        src={imagePath}
                                        alt={`${categoryName} thumbnail`}
                                        className="max-w-full max-h-full object-contain"
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                            e.target.parentNode.innerHTML = '<span style="color:red; font-size:12px;">ICON FAIL</span>';
                                        }}
                                    />
                                </div>
                                <h3 className="font-uber text-[16px] font-normal leading-[24px] text-black mb-2">{categoryName}</h3>
                            </Link>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}